import { Card, Col, Row } from 'react-bootstrap';
import { useAppContext } from '@/Main';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

const METRIC_COUNT = 4;
const TIME_RANGE_COUNT = 6;

const MetricLineTimeChartSkeleton = () => {
  const {
    config: { theme }
  } = useAppContext();

  const shimmerBg = changeBgColor(theme);

  return (
    <div>
      <div className="mb-3">
        <Row className="g-2">
          {Array.from({ length: METRIC_COUNT }).map((_, index) => (
            <Col key={index} xs={12} sm={6} xl={3}>
              <Card className="h-100 border border-300">
                <Card.Body className="p-3">
                  <div className="d-flex align-items-start justify-content-between gap-2 mb-2">
                    <span
                      className="metric-line-chart-skeleton-checkbox"
                      style={{ background: shimmerBg }}
                    />
                    <TextLoading width={14} height={14} isWidthPx />
                  </div>
                  <TextLoading width={55} height={12} />
                  <div className="mt-2">
                    <TextLoading width={45} height={28} />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <Card>
        <Card.Body>
          <div className="d-flex gap-2 flex-wrap align-items-center w-100">
            <div className="d-flex gap-2 mt-3 align-items-center">
              <TextLoading width={60} height={14} isWidthPx />
              <span
                className="metric-line-chart-skeleton-switch"
                style={{ background: shimmerBg }}
              />
            </div>
            <div className="d-flex gap-2 mt-3 align-items-center">
              <TextLoading width={55} height={14} isWidthPx />
              <span
                className="metric-line-chart-skeleton-switch"
                style={{ background: shimmerBg }}
              />
            </div>
            <div className="d-flex flex-wrap align-items-center mt-3 gap-1 ms-auto">
              {Array.from({ length: TIME_RANGE_COUNT }).map((_, index) => (
                <span
                  key={index}
                  className="metric-line-chart-skeleton-button"
                  style={{ background: shimmerBg }}
                />
              ))}
            </div>
          </div>

          <div className="mt-7 mt-lg-5 bg-100 rounded-2 metric-line-chart-skeleton-chart">
            <div className="metric-line-chart-skeleton-y-axis">
              {Array.from({ length: 5 }).map((_, index) => (
                <TextLoading key={index} width={28} height={10} isWidthPx />
              ))}
            </div>
            <div className="metric-line-chart-skeleton-lines">
              {[92, 78, 85, 68, 74, 58, 63, 48, 55, 42, 50, 38, 45, 35, 40, 30].map(
                (width, index) => (
                  <span
                    key={index}
                    className="metric-line-chart-skeleton-line-bar"
                    style={{
                      background: shimmerBg,
                      width: `${width}%`
                    }}
                  />
                )
              )}
            </div>
            <div className="metric-line-chart-skeleton-x-axis">
              {Array.from({ length: 7 }).map((_, index) => (
                <TextLoading key={index} width={48} height={10} isWidthPx />
              ))}
            </div>
          </div>
        </Card.Body>
      </Card>

      <style>{`
        .metric-line-chart-skeleton-checkbox,
        .metric-line-chart-skeleton-switch,
        .metric-line-chart-skeleton-button,
        .metric-line-chart-skeleton-line-bar {
          background-size: 200% 100%;
          background-position: 100% 0;
          animation: run 2s infinite;
        }

        .metric-line-chart-skeleton-checkbox {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          display: inline-block;
          flex-shrink: 0;
        }

        .metric-line-chart-skeleton-switch {
          width: 32px;
          height: 18px;
          border-radius: 999px;
          display: inline-block;
        }

        .metric-line-chart-skeleton-button {
          width: 52px;
          height: 28px;
          border-radius: 0.25rem;
          display: inline-block;
          margin: 0 4px;
        }

        .metric-line-chart-skeleton-chart {
          position: relative;
          height: 24.75rem;
          padding: 1.5rem 1rem 1rem;
          overflow: hidden;
        }

        .metric-line-chart-skeleton-y-axis {
          position: absolute;
          top: 1.5rem;
          left: 1rem;
          bottom: 2.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 32px;
        }

        .metric-line-chart-skeleton-lines {
          position: absolute;
          top: 2rem;
          left: 3.5rem;
          right: 1rem;
          bottom: 2.75rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          direction: ltr;
        }

        .metric-line-chart-skeleton-line-bar {
          display: block;
          height: 3px;
          border-radius: 999px;
        }

        .metric-line-chart-skeleton-line-bar:nth-child(even) {
          opacity: 0.55;
        }

        .metric-line-chart-skeleton-x-axis {
          position: absolute;
          left: 3.5rem;
          right: 1rem;
          bottom: 0.75rem;
          display: flex;
          justify-content: space-between;
          gap: 0.5rem;
        }
      `}</style>
    </div>
  );
};

export default MetricLineTimeChartSkeleton;
